export default {"src":"/_next/static/media/icon_chat_blocked.f69e1c2a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};